import React from "react";
import PhotosGallery from "../../components/PhotosGallery/PhotosGallery";
import Participa from "../../components/Participa/Participa";

import LogoFlama from "../../assets/logo-flama.js";
import videoSource from "../../assets/videos/LaFlama-quiSom-video.mp4";

import "./Qui-som.css";

function Quisom() {
  return (
    <>
      <section className="qui-som">
        <div className="qui-som__section">
          <video controls className="qui-som__section-video">
            <source src={videoSource} type="video/mp4" />
            Tu navegador no soporta el elemento de video.
          </video>
          <div className="qui-som__section-text">
            <h1>Qui som</h1>
            <p>
              El Casal Popular La Flama neix el 2024 arran de la necessitat de
              crear un espai autogestionat on les persones que creiem que un món
              millor és possible puguem trobar-nos, organitzar-nos i treballar
              per construir una Cerdanyola més participativa, empoderada i
              socialment justa. Actuant localment però pensant globalment,
              formem part de la Xarxa de Casals i Ateneus per tal de contribuir
              i coordinar-nos en la construcció d'un poder popular a escala dels
              Països Catalans.
            </p>
          </div>
        </div>
        <div className="qui-som__fire">
          <LogoFlama height={75} width={55} />
        </div>
        <div className="qui-som__pictures">
          <PhotosGallery />
        </div>
      </section>
      <Participa />
    </>
  );
}

export default Quisom;
